import React from 'react';

import { EchoNavigate, EchoSlot, useEcho } from '@betterment/js-runtime';
import { useLoaderData } from 'react-router-dom';

import { ReportsLayout, ReportsTab } from './ReportsLayout';

import { FullPageLoader } from '../FullPageLoader';

export const ReportsEchoRoute: React.FC<{ activeTab: ReportsTab }> = ({ activeTab }) => {
  const { echo, onSubmit } = useEcho(useLoaderData());

  if (echo.type === 'navigation') {
    return <EchoNavigate echo={echo} fallback={<FullPageLoader />} />;
  }

  return (
    <ReportsLayout activeTab={activeTab}>
      <EchoSlot slot={echo.slots.main!} onSubmit={onSubmit} />
    </ReportsLayout>
  );
};
